import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as api from '../../services/api';
import { useAuth } from './AuthContext';
import { AuthPageShell, fieldClass, primaryButtonClass } from './AuthPageShell';

export function InvitationPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState<string | null>(null);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);
  const [loadError, setLoadError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    api
      .validateInvitation(token)
      .then((invitation) => {
        setEmail(invitation.email);
        setName(invitation.name);
      })
      .catch(() => setLoadError('Invitasjonen er ugyldig eller utløpt.'));
  }, [token]);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (!token) return;
    setPending(true);
    setError(null);
    try {
      await api.acceptInvitation(token, name, password);
      await refresh();
      navigate('/', { replace: true });
    } catch {
      setError('Kunne ikke fullføre invitasjonen. Sjekk at passordet er minst 12 tegn.');
    } finally {
      setPending(false);
    }
  }

  if (loadError) {
    return (
      <AuthPageShell title="Ugyldig invitasjon" lead="">
        <p className="text-sm text-red-700">{loadError}</p>
      </AuthPageShell>
    );
  }

  return (
    <AuthPageShell title="Fullfør registrering" lead={email ? `Invitert som ${email}` : 'Laster…'}>
      <form onSubmit={submit} className="space-y-5">
        <label className="block text-sm font-medium">
          Navn
          <input className={fieldClass} required value={name} onChange={(event) => setName(event.target.value)} />
        </label>
        <label className="block text-sm font-medium">
          Passord (minst 12 tegn)
          <input
            className={fieldClass}
            type="password"
            minLength={12}
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {error && (
          <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-800" role="alert">
            {error}
          </p>
        )}
        <button className={primaryButtonClass} disabled={pending || !email} type="submit">
          {pending ? 'Oppretter…' : 'Opprett bruker og logg inn'}
        </button>
      </form>
    </AuthPageShell>
  );
}
